import { render, staticRenderFns } from "./PixQrCard.vue?vue&type=template&id=10de0470&scoped=true"
import script from "./PixQrCard.vue?vue&type=script&lang=js"
export * from "./PixQrCard.vue?vue&type=script&lang=js"
import style0 from "./PixQrCard.vue?vue&type=style&index=0&id=10de0470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de0470",
  null
  
)

export default component.exports